<template>
  <div class="criminal-apply">
    <Row class="detail-header">
      <span>行政申请</span>
      <ButtonGroup size="small" class="lawsuit-btn">
        <Button :type="tabActive=='sumbitMaterials'?'primary':'default'" @click="tabActive='sumbitMaterials'">材料申请</Button>
        <!-- <Button :disabled="disabledCtrl" :type="tabActive=='senDdata'?'primary':'default'" @click="tabActive='senDdata'">材料寄送</Button> -->
      </ButtonGroup>
    </Row>
    <Row class="lawsuit-form">
      <submit-material v-if="tabActive=='sumbitMaterials'" :process-id="processId" :case-id="caseId" @getAuditState="getState" v-on="$listeners" />
      <send-data v-else :process-id="processId" :case-id="caseId" v-on="$listeners" />
    </Row>
  </div>
</template>
<script>
import submitMaterial from './submitMaterial.vue'
import sendData from './sendData.vue'
export default {
  components: {
    submitMaterial,
    sendData
  },
  props: ['processId', 'caseId'],
  data () {
    return {
      tabActive: 'sumbitMaterials',
      disabledCtrl: true
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {},
  updated() {},
  methods: {
    getState(state) {
      if (state) {
        this.disabledCtrl = false
      } else {
        this.disabledCtrl = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/globalStyle.scss';
@import '../../civilCase/caseCommon.scss';
.criminal-apply{
    .lawsuit-form{
        margin-top:10px;
        padding-top:10px;
        border-top:1px solid $borderColor;
    }
 }
</style>



// WEBPACK FOOTER //
// src/view/administrativeCase/administrativeApply/index.vue